import React, { useState } from 'react'
import { AXIOS } from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { useDropzone } from 'react-dropzone'
import { ChromePicker } from 'react-color'
import { v4 as uuidv4 } from 'uuid'
import { useForm } from 'react-hook-form'
import _ from 'lodash'
import parser from 'react-html-parser'

import { Title, Picture, Heading } from './common/Themes'

import { setLoading, setFetch } from '../redux/actions'


const NewOffre = () => {

    const dispatch = useDispatch()
    const { activites } = useSelector(state => state.fetch)
    const { fetch } = useSelector(state => state.config)

    const [name, setName] = useState('')
    const [file, setFile] = useState({})
    const [color, setColor] = useState({ hex: '#FF5C00', rgb: { r: 245, g: 68, b: 46, a: .8 } })
    const history = useHistory()

    const { handleSubmit, register, errors } = useForm()

    const onSubmit = async values => {
        try {
            dispatch(setLoading(true))
            const uuid = uuidv4()
            const body = {
                ...values,
                web: 1,
                oid: uuid,
                color: color.hex,
                image: `/uploads/offres/${uuid}.png?cache=${new Date().getTime()}`
            }

            // 👽 NEW IMAGE REQUEST
            if (!_.isEmpty(file)) {
                const formData = new FormData()
                formData.append('file', file)
                console.log('upload image')
                await AXIOS.post(`/api/v1/uploads/offres/${uuid}`, formData);
            }
            // 👽 NEW OFFRE REQUEST
            const res = await AXIOS.post('/api/v1/offres', body);
            console.log(res.data)
            dispatch(setFetch(!fetch))
            history.push(`/offre/${res.data.offre.oid}`)
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    // DROPZONE IMAGE --------------------------------------------------------------------------------------------------------
    const [imageURL, setImageURL] = useState('')

    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.map(file => {
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
                setFile(acceptedFiles[0])
                const reader = new FileReader();
                reader.onload = (event) => {
                    setImageURL(event.target.result);
                };
                reader.readAsDataURL(file);
            });
        }
    });

    return (
        <div className="gestion">
            <div className="gestion__header">
                <h4 className="gestion__title">Nouveau offre</h4>
            </div>
            <div className="gestion__wrapper">
                <form onSubmit={handleSubmit(onSubmit)} className="form">
                    <div className="form__container">
                        <div className="form__inputboxWrapper">
                            <Title color={'#183a68'}>Fiche offre :</Title>
                            <div className="form__inputboxWrapper" style={{ width: '100%' }}>

                                <div className="form__inputbox">
                                    <label htmlFor="name" className="form__label">Nom <span style={{ textTransform: 'lowercase', letterSpacing: '.2px' }}>( pour un retour à ligne "&lt;br/&gt;" )</span></label>
                                    <input name="name" onChange={e => setName(e.target.value)} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.name && errors.name.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">Activité</label>
                                    <select name="aid" ref={register({ required: 'Required' })} className="form__input" style={{ padding: '0 1rem' }}>
                                        {activites.map(({ aid, name }) => <option className="form__dropdown" key={aid} value={aid}>{name}</option>)}
                                    </select>
                                    {errors.aid && errors.aid.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">Classement</label>
                                    <input name="classement" type="number" defaultValue="1" min="1" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.classement.message}
                                </div>

                            </div>
                        </div>
                        <div style={{ width: '25%', height: '100%' }}>
                            <Title color={'#183a68'}>Offre démo :</Title>
                            <div className="card">
                                <Heading color={color.hex}>{parser(name)}</Heading>
                                <Picture image={imageURL ? imageURL : '/img/default_image.png'}>&nbsp;</Picture>
                            </div>
                        </div>
                    </div>

                    <div className="form__container" style={{ justifyContent: 'flex-start' }}>

                        <div className="gestion__imageWrapper">
                            <label htmlFor="image" className="form__label">Importer une image</label>
                            <div {...getRootProps()} className="dropzone">
                                <input {...getInputProps()} />
                                <img src="/img/icon/upload.svg" alt="upload" style={{ width: '120px' }} />
                            </div>
                        </div>

                        <div className="gestion__colorWrapper" style={{ marginLeft: '10rem' }}>
                            <label htmlFor="color" className="form__label">Choisir un color</label>
                            <div style={{ marginTop: '1rem' }}>
                                <ChromePicker color={color} onChange={color => setColor(color)} />
                            </div>
                        </div>
                    </div>


                    <div className="gestion__buttonWrapper">
                        <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#0D53FC' }}>Ajouter</button>
                        <Link to='/offres'>
                            <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#fc114c' }}>Fermer</button>
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default NewOffre